module.exports = __webpack_public_path__ + "static/studio-b-rack-1180874debf380a9b9c29730fb968a47.jpg";